const {
    checkValueExistence,
    ArrayToArrayMatcher
} = require('../utils')
const YesOrNoOperators = {
    is_any_of_yes_or_no: {
        id: 'is_any_of_yes_or_no',
        matcher: (value, matchValue) => {
            let matchValues = [];
            try {
                matchValues = matchValue.split(',');
            } catch(e){
                console.error(e)
            }
            if(!value && matchValues.includes('Unknown')) return true;
            if(typeof value === 'boolean') {
                value = value === true ? ['Yes'] :  ['No']
            }
            return ArrayToArrayMatcher(value, matchValue);
        }
    },
    is_none_of_yes_or_no: {
        id: 'is_none_of_yes_or_no',
        matcher: (value, matchValue) => {
            let matchValues = [];
            try {
                matchValues = matchValue.split(',');
            } catch(e){
                console.error(e)
            }
            if(!value && matchValues.includes('Unknown')) return false;
            if(!value) return true;

            if(typeof value === 'boolean') {
                value = value === true ? ['Yes'] :  ['No']
            }

            return !(ArrayToArrayMatcher(value, matchValue));
        }
    },
    is_known_for_yes_or_no: {
        id: 'is_known_for_yes_or_no',
        matcher: (value, matchValue) => {
            return checkValueExistence(value);
        }
    },
    is_unknown_for_yes_or_no: {
        id: 'is_unknown_for_yes_or_no',
        matcher: (value, matchValue) => {
            return !(checkValueExistence(value));
        }
    }
}
module.exports.YesOrNoOperators = YesOrNoOperators;